import React from 'react';
import { isSafari, isIOS } from 'react-device-detect';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import PageLines from '../@common/PageLines';
import { LargePageLineText, SmallPageLineText } from '../@common/PageLineText';
import BaseInput from 'html-worksheets/@common/BaseInput';
import GroupedPageLines from '../@common/GroupedPageLines';
import NameAndDateLines from '../@common//NameAndDateLines';
import SmallBoxBorderLines from 'html-worksheets/@common/SmallBoxBorderLines';
import PortraitPageLines from 'html-worksheets/@common/portrait/PortraitPageLines';
import { determineStyleBasedOnLineWidth, getFontSize } from '../../utils/style-utils';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

const GraphicOrganizer = ({ onChange, isCursive, isNarrow, valueMap, printRef }) => {
  const bookFont = isCursive ? 'Cursive-Book' : 'Print-Wide-Light';
  const numOfLines = isNarrow ? 5 : 3;
  const lineArray = [...Array(numOfLines).keys()];
  const marginTop = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isSafari || isIOS ? '-10px' : '-22px',
    narrow: '-17px',
    cursive: isSafari || isIOS ? '-14px' : '-32px',
    regular: '-29px'
  });
  const marginTopInput = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isSafari || isIOS ? '-2px' : '-9px',
    narrow: '-3px',
    cursive: isSafari || isIOS ? '-10px' : '-19px',
    regular: '-13px'
  });

  const fontSize = getFontSize(isCursive, isNarrow);

  const classes = useStyles({ marginTop });

  const baseInputStyles: any = {
    fontFamily: bookFont,
    color: '#000',
    style: {
      fontSize: fontSize,
      width: 325,
      marginLeft: 15,
      marginTop: marginTop,
      color: '#000'
    }
  };

  return (
    <PortraitPaperLayout isNarrow={isNarrow} printRef={printRef}>
      <NameAndDateLines isCursive={isCursive} fontFamily={bookFont} isNarrow={isNarrow} top={25} />
      <PageLines width={800} className={classes.pageLine} isNarrow={isNarrow}>
        <LargePageLineText className={classes.pageLineText}>
          <BaseInput
            // eslint-disable-next-line
            onChange={({ target }) => onChange({ [1]: target.value })}
            showBackground={true}
            fontFamily={bookFont}
            color="#000"
            placeholder={t('enterABContent')}
            fontSize={fontSize}
            maxLength={45}
            marginTop={marginTopInput}
            width={800}
            value={valueMap[1]}
            style={{
              lineHeight: isCursive ? 'unset' : 'normal'
            }}
          />
        </LargePageLineText>
      </PageLines>
      <Box className={classes.bxContainer}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '0 0 25px'
          }}
        >
          {lineArray.map((x, idx) => (
            <GroupedPageLines
              key={idx}
              top={35}
              isNarrow={isNarrow}
              marginPageLines={isNarrow ? '0px 25px 45px' : '10px 25px 45px'}
            />
          ))}
        </Box>
      </Box>
      <Box>
        <PortraitPageLines
          repeatLines={false}
          isNarrow={isNarrow}
          paddingBtwnCols="50px"
          rowMargin={isNarrow ? '65px 0 20px 0' : '65px 0 30px 0'}
          col1={
            <Box>
              <SmallPageLineText>
                <BaseInput
                  // eslint-disable-next-line
                  onChange={({ target }) => onChange({ [2]: target.value })}
                  showBackground={true}
                  {...baseInputStyles}
                  placeholder={isCursive && !isNarrow ? t('aContent') : t('enterAContent')}
                  fontSize={fontSize}
                  fontFamily={bookFont}
                  value={valueMap[2]}
                />
              </SmallPageLineText>
            </Box>
          }
          col2={
            <Box>
              <SmallPageLineText>
                <BaseInput
                  // eslint-disable-next-line
                  onChange={({ target }) => onChange({ [3]: target.value })}
                  showBackground={true}
                  {...baseInputStyles}
                  placeholder={isCursive && !isNarrow ? t('bContent') : t('enterBContent')}
                  fontSize={fontSize}
                  maxLength={15}
                  fontFamily={bookFont}
                  value={valueMap[3]}
                />
              </SmallPageLineText>
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          flex: 1
        }}
      >
        <SmallBoxBorderLines
          pageLineCount={5}
          isNarrow={isNarrow}
          marginPageLines={isNarrow ? '0px 25px 45px' : '10px 25px 45px'}
        />
        <SmallBoxBorderLines
          pageLineCount={5}
          isNarrow={isNarrow}
          marginPageLines={isNarrow ? '0px 25px 45px' : '10px 25px 45px'}
        />
      </Box>
    </PortraitPaperLayout>
  );
};

const useStyles = makeStyles(() => ({
  pageLine: {
    alignSelf: 'center !important',
    margin: '155px 25px 0px !important',
    position: 'relative',
    top: '-50px !important',
    left: '0px !important'
  },
  pageLineText: {
    justifyContent: 'space-between !important',
    width: '514px !important',
    fontSize: '52px !important',
    marginTop: '-18px !important',
    paddingLeft: '15px'
  },
  bxContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '2px solid #000',
    borderRadius: 25,
    margin: '-15px 32px',
    width: 'max-content',
    alignSelf: 'center'
  }
}));

export default GraphicOrganizer;
